import Vue from 'vue';
import moment from 'moment';
import linkifyHtml from 'linkifyjs/html';
import timeago from 'timeago.js';

import UserUtils from './utils/users';

Vue.filter('percentage', function(value) {
    return Math.round(value * 10) / 10;
});


Vue.filter('deCamelCase', function(str) {
    return str.replace(/([A-Z])/g, ' $1')
    .replace(/^./, function(str){ return str.toUpperCase(); })
});

Vue.filter('nullcheck', function(value) {
    // Populi returns string NULL for some zero values
    if (value === 'NULL') return '0.00';
    return value;
});

Vue.filter('linkify', function(val) {

    return linkifyHtml(val, {
        defaultProtocol: 'https'
    });
});

Vue.filter('deslugify', function(str) {
    return str.split('_').map(function(s) {
        return s.charAt(0).toUpperCase() + s.slice(1);
    }).join(' ')
});

Vue.filter('trim', function(str) {
    return str.trim();
});


Vue.filter('formatCourseTags', function(tags) {
    function titleCase(str) {
      str = str.toLowerCase().split(' ');
      for (var i = 0; i < str.length; i++) {
        str[i] = str[i].charAt(0).toUpperCase() + str[i].slice(1);
      }
      return str.join(' ');
    }
    return titleCase(tags.join(', ').replace(/_/g, ' ')).replace('3d', '3D')
})

Vue.filter('units', function(size) {
    function formatBytes(a,b){if(0==a)return"0 Bytes";var c=1024,d=b||2,e=["Bytes","KB","MB","GB","TB","PB","EB","ZB","YB"],f=Math.floor(Math.log(a)/Math.log(c));return parseFloat((a/Math.pow(c,f)).toFixed(d))+" "+e[f]}

    return formatBytes(size);

});
Vue.filter('unescape', function(text) {
    return text.replace(/&lt;/g, '<')
});

Vue.filter('roleIcon', function(roles, termIds) {
    return UserUtils.getDisplayRoleIcon({ roles, termIds }) || '';
});

Vue.filter('ucwords', function(str) {
    str = str.toLowerCase();
    return str.replace(/(^([a-zA-Z\p{M}]))|([ -][a-zA-Z\p{M}])/g,
    function(s){
      return s.toUpperCase();
    });
})

Vue.filter('stripTags', function(text) {
    var regex = /(<([^>]+)>)/ig;
    return text.replace(regex, '').replace(/&nbsp;/g, ' ');
})

Vue.filter('filenameFromUrl', function(url) {
    return decodeURIComponent(url.split('/').pop().split('?')[0]);
})

Vue.filter('timeago', function(date) {
    return timeago().format(new Date(date));
});

Vue.filter('timelineDate', function(date) {
    return moment(date).format('MMM D')
})
Vue.filter('longDate', function(d) {
    d = new Date(d);
    return moment(d).format('dddd, MMMM Do, YYYY @ h:mma');
});

Vue.filter('localLongDate', function(d) {
    d = new Date(d);
    console.log(d);
    return moment.tz(d, moment.tz().guess).format('dddd, MMMM Do, YYYY @ h:mma');
});

Vue.filter('shortDate', function(d) {
    return moment(d).format('YYYY/MM/DD @ h:mma');
});

Vue.filter('timeOnly', function(d) {
    return moment(d).format('h:mma');
});

Vue.filter('intakeDate', function(d) {
    return moment(d).format('MMMM YYYY');
});

Vue.filter('monthAndDay', function(d) {
    return moment(d).format('MMM DD');
});

Vue.filter('localShortDate', function(d) {
    return moment.tz(d, moment.tz().guess).format('YYYY/MM/DD @ h:mma');
});
Vue.filter('checkinDate', function(d) {
    return moment.tz(d, 'America/Vancouver').format('YYYY/MM/DD');
});

Vue.filter('timecode', function(t) {
   return new Date(Math.round(t) * 1000).toISOString().substr(11, 8);
});

Vue.filter('vancouverTime', function(d) {
    var userTime = moment(d);
    var offset = new Date().getTimezoneOffset();
    if (offset < 420) { // yes Vancouver's UTC offset is 420 minutes
        userTime = userTime.add(420 - offset,'minutes');
    } else if (offset > 420) {
        userTime = userTime.subtract(offset - 420,'minutes');
    }
    userTime =  userTime.toDate();
    return userTime.toGMTString().replace('GMT','');
});
Vue.filter('localDate', function(date) {
    return new Date(date).toLocaleString();
});

Vue.filter('journeyDate', function(d) {
    d = moment(d).format('MMM Do, YYYY');
    return d.replace( /(\d)(st|nd|rd|th)/g, '$1<sup>$2</sup>' );
});

Vue.filter('dayOnly', function(date) {
    return moment(date).format('dddd, MMMM D, YYYY')
});

Vue.filter('monthAndYear', function(date) {
    return moment(date).format('MMM YYYY')
});

Vue.filter('fullMonthAndYear', function(date) {
    return moment(date).format('MMMM YYYY')
});
Vue.filter('dayMonthYear', function(date) {
    return moment(date).format('D/MM/YYYY')
});

Vue.filter('excerpt', function(text, length) {
    if (!length) length = 5;
    text = text.replace(/<(?:.|\n)*?>/gm, '').replace(/&nbsp;/g, ' ').split(/\s+/);
    let excerpt = text.slice(0,length);

    if (text.length > excerpt.length) {
        console.log(excerpt);
        excerpt.push('...')
    }
    return excerpt.join(' ');
});

Vue.filter('audioTime', function(seconds) {
    seconds = parseInt(seconds);
    var hours = parseInt( seconds / 3600 );
    seconds = seconds % 3600;
    var minutes = parseInt( seconds / 60 ); // 60 seconds in 1 minute
    seconds = seconds % 60;
    return( ("00" + hours).slice(-2) +":"+("00" + minutes).slice(-2)+":"+("00" + seconds).slice(-2));
});

Vue.filter('userTimezone', function(time) {
    var d = new Date();
    function convertTo24Hour(time) {
        var hours = parseInt(time.substr(0, 2));
        if (time.indexOf('am') != -1 && hours == 12) {
            time = time.replace('12', '0');
        }
        if (time.indexOf('pm') != -1 && hours < 12) {
            time = time.replace(hours, (hours + 12));
        }
        return time.replace(/(am|pm)/, '');
    }
    var rightNow = moment.utc();
    time = convertTo24Hour(time).split(':');

    var VancouverTime = moment.tz.zone('America/Vancouver').offset(rightNow);
    var UserTime = moment.tz.zone(moment.tz.guess()).offset(rightNow);

    var minutesDifference = (VancouverTime - UserTime);
    var hours = parseInt(minutesDifference / 60)
    var minutes = minutesDifference % 60;
    d.setHours( (parseInt(hours, 10) + parseInt(time[0], 10)), parseInt(minutes,10) + parseInt(time[1],10), 0);

    return moment(d.getHours() + ":" + d.getMinutes(), 'HH:mm').format('hh:mma');

});

Vue.filter('nobreak', function(text) {
    if (!text) text = '';
    return text.replace('<br />', ' ')
});

Vue.filter('minutesAndSeconds', function(time) {
    time = Math.round(time)
    var hrs = ~~(time / 3600);
    var mins = ~~((time % 3600) / 60);
    var secs = time % 60;

    // Output like "1:01" or "4:03:59" or "123:03:59"
    var ret = "";

    if (hrs > 0) {
        ret += "" + hrs + ":" + (mins < 10 ? "0" : "");
    }

    ret += "" + mins + ":" + (secs < 10 ? "0" : "");
    ret += "" + secs;
    return ret;
});

Vue.filter('dateFormat', function(date) {

        if (typeof date !== 'string') return 'N/A';

        date = new Date(date);
        var hours = date.getHours();
        var minutes = date.getMinutes();
        var ampm = hours >= 12 ? 'pm' : 'am';
        hours = hours % 12;
        hours = hours ? hours : 12; // the hour '0' should be '12'
        minutes = minutes < 10 ? '0' + minutes : minutes;
        var strTime = hours + ':' + minutes + ' ' + ampm;
        return date.getMonth() + 1 + "/" + date.getDate() + "/" + date.getFullYear() + "  " + strTime;

});

Vue.filter('timeSince', function(date) {
            date = new Date(date);

            var seconds = Math.floor((new Date() - date) / 1000);

            var interval = Math.floor(seconds / 31536000);

            if (interval > 1) {
                return interval + " years";
            }
            interval = Math.floor(seconds / 2592000);
            if (interval > 1) {
                return interval + " months";
            }
            interval = Math.floor(seconds / 86400);
            if (interval > 1) {
                return interval + " days";
            }
            interval = Math.floor(seconds / 3600);
            if (interval > 1) {
                return interval + " hours";
            }
            interval = Math.floor(seconds / 60);
            if (interval > 1) {
                return interval + " minutes";
            }
            if (seconds < 0) seconds = 0;
            return Math.floor(seconds) + " seconds";
});


Vue.filter('sessionDay', function(date) {
    return moment(date).format('dddd MMMM DD, YYYY');
});

Vue.filter('sessionTime', function(date) {
    return moment(date).format('h:mm A');
})




// WEBPACK FOOTER //
// ./src/filters.js